import { bgStyle } from "@/lib/gradients";
import { parseVideoEmbed } from "@/lib/embeds";

// Visionneuse plein écran (téléphone) : quel écran pour une publication ?
// "video" → VideoViewerMobile · "embed" → VideoViewerMobile (vidéo YouTube / Facebook par lien, lecteur intégré
// avec le son sur fond noir) · "photo" → PhotoViewerMobile (photos ET albums mêlant vidéos : défilement entre tous
// les médias) · "text" → PhotoViewerMobile (carte texte sur fond coloré, même écran noir que les photos) · null →
// fiche claire « Publication de … » (texte simple, audio, lien article…).
export const postHasPhotos = (post) =>
  !!post && ((post.images?.length > 0) || (Array.isArray(post.album) && post.album.some((m) => m.type !== "video")));

// Album = 2+ médias (photos et/ou vidéos) ; la liste ordonnée fait foi, sinon les photos seules.
export const postMediaItems = (post) => {
  if (!post) return [];
  if (Array.isArray(post.album) && post.album.length > 1) return post.album;
  return (post.images || []).map((u) => ({ type: "image", url: u }));
};

export const postHasVideoAlbum = (post) =>
  !!post && Array.isArray(post.album) && post.album.length > 1 && post.album.some((m) => m.type === "video");

// « Avant / Après » : exactement 2 médias du même type → { kind: "image" | "video", items }.
export const postBeforeAfter = (post) => {
  if (!post || post.album_layout !== "before_after") return null;
  const items = postMediaItems(post);
  if (items.length !== 2 || items[0].type !== items[1].type) return null;
  return { kind: items[0].type === "video" ? "video" : "image", items };
};

export const postIsSingleVideo = (post) =>
  !!post && !!(post.hls_url || post.video_url) && !(Array.isArray(post.album) && post.album.length > 1);

// Carte texte sur fond coloré/photo (même condition que l'affichage BgTextFrame dans PostCard).
export const postIsBgText = (post) =>
  !!post && !!post.bg && !!bgStyle(post.bg) && !!(post.content || "").trim()
  && !post.images?.length && !post.video_url && !post.hls_url && !post.audio_url
  && !(Array.isArray(post.album) && post.album.length > 0);

// Vidéo par lien (YouTube / Facebook) : embed serveur, sinon détecté dans le texte — jamais avec des photos.
export const postEmbedOf = (post) => {
  if (!post || post.images?.length || post.video_url || post.hls_url) return null;
  const e = (post.embed && post.embed.src) ? post.embed : parseVideoEmbed(post.content || "");
  return e?.src ? e : null;
};

export const mobileViewerKind = (post) => {
  if (postIsSingleVideo(post)) return "video";
  if (postHasPhotos(post) || postHasVideoAlbum(post)) return "photo";
  if (postIsBgText(post)) return "text";
  if (postEmbedOf(post)) return "embed";
  return null;
};
